module.exports = __webpack_public_path__ + "static/lucaswork2-5eacf26cf63a0d804d119027b770c4db.jpg";